import React from 'react';
import { Box, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { YearOption } from '../../types/onboarding';

interface YearPickerProps {
  questionTextKey: string;
  options: YearOption[];
  value?: number;
  onChange: (value: number) => void;
}

const YearPicker: React.FC<YearPickerProps> = ({
  value,
  onChange,
  options,
}) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const minYear = Math.min(...options.map(o => o.value));
  const maxYear = Math.max(...options.map(o => o.value));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(event.target.value, 10);
    if (!isNaN(newValue) && newValue >= minYear && newValue <= maxYear) {
      onChange(newValue);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '400px',
        margin: '0 auto',
      }}
    >
      <TextField
        fullWidth
        type="number"
        value={value || ''}
        onChange={handleChange}
        placeholder={t('common.select_year')}
        inputProps={{
          min: minYear,
          max: maxYear,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            borderRadius: 3,
            height: '56px',
            '& fieldset': {
              border: 'none',
            },
            '&:hover fieldset': {
              border: 'none',
            },
            '&.Mui-focused fieldset': {
              border: 'none',
            },
          },
          '& .MuiOutlinedInput-input': {
            textAlign: 'left',
            pl: 3,
            fontSize: '1rem',
            fontWeight: 500,
            color: 'black',
            '&::placeholder': {
              color: 'rgba(0, 0, 0, 0.6)',
              opacity: 1,
            },
          },
        }}
      />
    </Box>
  );
};

export default YearPicker; 